import { call, put, takeEvery } from 'redux-saga/effects';
import { addNote } from '../../requests/add_note_request';
import { getLeadProfileWithNotes } from '../../requests/get_lead_profile_request';
import { addNoteRequestSuccess, addNoteRequestFailure } from '../actions/add_note.actions';
import { ADD_LEADS_NOTE_REQUEST } from '../constants/add_note.constants';
import { message_success, message_error } from '../../../../../components/Message';

function* addNoteRequest({ _id, note }) {
    const response = yield call(addNote, _id, note);
    if (response?.result) {
        const data = yield call(getLeadProfileWithNotes, _id);
        yield put({ type: 'GET_LEAD_HISTORY_REQ', leadId: _id });
        yield put(addNoteRequestSuccess(data.options.notes));
        message_success('Note added successfully!');
    } else {
        yield put(addNoteRequestFailure(response?.error));
        message_error('Something gone wrong!');
    }
}

export default function* addNoteSaga() {
    yield takeEvery(ADD_LEADS_NOTE_REQUEST, addNoteRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/add_note.saga.js